<script setup>
</script>

<template>
  <div class="bg-pageTertiary flex items-center justify-center flex-col gap-6 p-6">
    <h2 class="text-[32px] text-textPrimary font-bold leading-10">
      {{ $t("邀请好友注册") }}
    </h2>
    <i18n-t
      keypath="轻松获得 {0}"
      scope="global"
      tag="label"
      class="text-textPrimary font-bold text-[32px] leading-10"
    >
      <span class="text-[32px] font-bold text-themeNormal">{{ $t("交易返佣") }}</span>
    </i18n-t>

    <img
      src="@/assets/images/referral/referral-header.png"
      alt=""
      class="w-[343px]"
    >
  </div>
</template>
